import { Component, HostBinding, Input, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';
import { DashboardService } from '@v3/dashboard/dashboard.service';
import { WinterModeService } from '@shared/components/snow-animation/services/winter-mode.service';

@Component({
    selector: 'ms-dashboard-sidebar-footer',
    templateUrl: './dashboard-sidebar-footer.component.html',
    styleUrls: ['./dashboard-sidebar-footer.component.scss'],
    standalone: false
})
export class DashboardSidebarFooterComponent {
  @HostBinding('class')
  @Input()
    color: 'purple' | 'yellow' = 'purple';

  @HostBinding('class.shrink')
  get isShrink() {
    return this._dashboardService.isShrink;
  }

  get user() {
    return this._userService.user;
  }

  get winterSeason(): WritableSignal<boolean> {
    return this._winterModeService.winterSeason;
  }

  get statusWinterMode(): WritableSignal<boolean> {
    return this._winterModeService.statusWinterMode;
  }

  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router,
    private readonly _userService: UserService,
    private readonly _dashboardService: DashboardService,
    private readonly _winterModeService: WinterModeService,
  ) {}

  logOut() {
    this._authService.logout();
    this._router.navigate(['/login']);
  }

  public changeWinterMode(): void {
    this._winterModeService.changeStatusWinterMode();
  }
}
